<template>
  <div id="history">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">

          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <alert-card></alert-card>
          <h2>ตั้งค่าบัญชีผู้ใช้</h2>
          <b-row>
            <b-col class="mb-2">
              <b-card bg-variant="light">
                <b-card-text v-if="dataReady">
                  <h4 class="mb-0">รหัสสมาชิก: {{form.userCode || 'ไม่ระบุ กรุณาแจ้งแอดมิน' }}</h4>
                  <small style="color: #f8f9fa;">ยอดเงินสินค้า {{ form.preBalance }} บาท ยอดเงินขนส่ง {{ form.cashBalance }} บาท</small><br>
                  <label for="form_firstname" class="mb-1">ชื่อจริง:</label>
                  <b-form-input id="form_firstname" autocomplete="off" class="mb-2" v-model="form.firstName" type="text" ></b-form-input>
                  <label for="form_lastname" class="mb-1">นามสกุล:</label>
                  <b-form-input id="form_lastname" autocomplete="off" class="mb-2" v-model="form.lastName" type="text" ></b-form-input>
                  <label for="form_tel" class="mb-1">เบอร์โทรศัพท์:</label>
                  <b-form-input id="form_tel" autocomplete="off" class="mb-2" v-model="form.telephoneNumber" type="tel" maxlength="10"></b-form-input>
                  <label for="form_address" class="mb-1">ที่อยู่จัดส่ง:</label>
                  <b-form-textarea id="form_address" autocomplete="off" class="mb-2" v-model="form.address" type="text" ></b-form-textarea>
                </b-card-text>

                <b-card-text v-if="!dataReady">
                  <label class="mb-1">ชื่อจริง:</label>
                  <b-skeleton type="input"></b-skeleton>
                  <label class="mb-1">นามสกุล:</label>
                  <b-skeleton type="input"></b-skeleton>
                  <label class="mb-1">เบอร์โทรศัพท์:</label>
                  <b-skeleton type="input"></b-skeleton>
                  <label class="mb-1">ที่อยู่จัดส่ง:</label>
                  <b-skeleton-img height="65px"></b-skeleton-img>
                </b-card-text>
                <div class="text-right">
                  <b-button @click="onUpdate">แก้ไขข้อมูล</b-button>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "Tracking",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    await this.getDataUser()
  },
  data() {
    return {
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        userId: '',
        userCode: '',
        userType: '',
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        address: '',
        preBalance: '0',
        cashBalance: '0',
        LAST_USER: 'LAST_USER'
      },
      dataReady: true,
    };
  },
  methods: {
    getDataUser() {
      this.dataReady = false;
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
        this.getDataProfile(lsUser.userName)
      } else {
        this.$router.push('/Login')
      }
    },
    getDataProfile(dt) {
      this.dataReady = false;
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/User/user_list?userName="+dt,
          {
            headers: this.getHeaderAPI('User_list', dt)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            // this.form = rs.data[0]
            let data = rs.data[0]
            this.form.userId = data.userId
            this.form.userCode = data.userCode
            this.form.userName = data.userName
            this.form.firstName = data.firstName
            this.form.lastName = data.lastName
            this.form.telephoneNumber = data.telephoneNumber
            this.form.address = data.address
            this.form.userType = data.userType

            this.form.preBalance = data.preBalance
            this.form.cashBalance = data.cashBalance

            this.form.LAST_USER = dt

            console.log('getDataProfile', this.form)
            this.dataReady = true;
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลส่วนตัวได้","error")
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true;
          // this.errored = true
        });
    },
    onUpdate (){
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/User/user_update",
          this.form,
          {
            headers: this.getHeaderAPI('User_update', this.form.userName)
          }
        )
        .then(async (response) => {
          console.log('registerUser', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","แก้ไขข้อมูลผู้ใช้เรียบร้อย","success")
            this.dataReady = true

            this.getDataProfile(this.userData.userName)
          } else {
            console.log('registerUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถแก้ไขข้อมูลผู้ใช้ได้","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถแก้ไขข้อมูลผู้ใช้ได้","error")
          this.dataReady = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

div.language-bar {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Profile.vue